import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getTotalVendasPorCidade } from '../services';
// @ts-ignore
import { FiltrosContextVendas } from '../Pages/VendasGerais/index.tsx';
import { format } from 'date-fns';

export const useTotalVendasPorCidade = () => {
  const filtros = useContext(FiltrosContextVendas);

  const listarTotalVendasPorCidade = async () => {
    const params = {
      filters: [
        {
          filter: 'STOREID',
          values: filtros?.lojasSelecionadas || null,
        },
        {
          filter: 'PRODUCTID',
          values: filtros?.produtosSelecionados || null,
        },
        {
          filter: 'STARTDATE',
          values: filtros?.periodoSelecionado?.length ? [format(filtros.periodoSelecionado[0], 'yyyy-MM-dd')] : null,
        },
        {
          filter: 'ENDDATE',
          values: filtros?.periodoSelecionado?.length ? [format(filtros.periodoSelecionado[1], 'yyyy-MM-dd')] : null,
        },
        {
          filter: 'STORETYPE',
          values: filtros?.tipoLojasSelecionadas || null,
        },
        {
          filter: 'CATEGORYLEVEL1',
          values: filtros?.categoriaNivel1Selecionadas || null,
        },
        {
          filter: 'CATEGORYLEVEL2',
          values: filtros?.categoriaNivel2Selecionadas || null,
        },
      ],
    };

    const resp = await getTotalVendasPorCidade(params);
    if (resp.length) {
      const fullCity = Object.keys(resp[0])[0]?.split('.');
      const sumSalesGross = Object.keys(resp[0])[1]?.split('.');
      return resp.map((item: { [x: string]: any }) => ({
        [fullCity[1]]: item[Object.keys(item)[0]],
        [sumSalesGross[1]]: parseFloat(item[Object.keys(item)[1]])?.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }),
      }));
    }
    return [];
  };

  const { isLoading, isError, data, error } = useQuery(['listaTotalVendasPorCidade', filtros], listarTotalVendasPorCidade, {
    retry: false,
    cacheTime: 6 * 180 * 1000,
    staleTime: 6 * 180 * 1000,
  });

  return {
    isLoading,
    isError,
    data,
    error,
  };
};
